/**
 * Aço vivo exposto pelo corte.
 *
 * Na oficina de corte, um vínculo liberado sumia da cena: a ferramenta fechava
 * e nada mudava à vista, porque a peça que desapareceu já estava escondida
 * atrás da chapa. O vínculo passou a ficar onde estava, seccionado — e é esta
 * face clara que o faz ser lido como cortado, e não como peça folgada.
 */
export function MaterialDeCorte() {
  return (
    <meshStandardMaterial
      color="#ffbe93"
      emissive="#ff6a2a"
      emissiveIntensity={0.5}
      metalness={0.3}
      roughness={0.28}
    />
  )
}

/**
 * Disco de aço vivo na ponta de um vínculo cilíndrico cortado.
 *
 * `eixo` é a direção em que o vínculo corre: o disco fica perpendicular a ela.
 */
export function FaceDeCorte({
  posicao,
  raio = 0.014,
  eixo = 'z',
}: {
  posicao: [number, number, number]
  raio?: number
  eixo?: 'x' | 'y' | 'z'
}) {
  const rotacao: [number, number, number] =
    eixo === 'z' ? [Math.PI / 2, 0, 0] : eixo === 'x' ? [0, 0, Math.PI / 2] : [0, 0, 0]

  return (
    <mesh position={posicao} rotation={rotacao}>
      <cylinderGeometry args={[raio, raio, 0.006, 12]} />
      <MaterialDeCorte />
    </mesh>
  )
}
